<template>
  <section class="ina_bag_product">
    <div>
      <p class="new_bag_brief" v-html="shopifyData.heading" />
      <div class="new_product_card">
        <div v-for="(value, key) in shopifyData.product" :key="key">
          <a :href="value.productLink" class="product_image">
            <img v-lazy="value.productImage" />
          </a>
          <a :href="value.productLink" class="ina_bag_name" v-html="value.productTitle" />
          <span class="ina_bag_price" v-html="value.productPrice" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
.ina_bag_product {
  margin: 0 10% 50px 10%;
}

.new_bag_brief {
  font-size: 13px;
  color: #000000;
  margin-bottom: 15px;
  line-height: 23px;
  font-family: 'Helvetica', sans-serif;
}

.ina_bag_name {
  color: #4f5050;
  font-size: 11px;
  display: inline-block;
  font-family: 'Helvetica Neue', sans-serif;
}

.ina_bag_price {
  color: #000;
  font-size: 12px;
  line-height: 24px;
  display: block;
  font-family: 'Helvetica', sans-serif;
}

.product_image img {
  width: 100%;
}

.product_image {
  display: block;
}

.new_product_card {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 5px;
}

@media only screen and (max-width: 768px) {
  .new_product_card {
    grid-template-columns: 1fr 1fr;
  }

  .ina_bag_name {
    font-size: 9px;
  }

  .ina_bag_price {
    line-height: 12px;
  }
}
</style>
<style>
@media only screen and (max-width: 768px) {
  #shopify-section-template--16823043031353__dan-alix-product .new_product_card div:nth-child(5n) {
    grid-column: 1 / span 2;
  }
}
</style>
